import { useState, useEffect, useCallback } from 'react'
import { fetchAuthConfig, type AuthMode, type SsoProvider } from '../utils/authConfig'

interface UseAuthModeResult {
  authMode: AuthMode | null
  providers: SsoProvider[]
  loading: boolean
  /** false when /auth/config could not be confidently resolved (transient). */
  ok: boolean
  /** Re-fetch the config (e.g. from a "retry" button). */
  refetch: () => void
}

export function useAuthMode(): UseAuthModeResult {
  const [authMode, setAuthMode] = useState<AuthMode | null>(null)
  const [providers, setProviders] = useState<SsoProvider[]>([])
  const [loading, setLoading] = useState(true)
  const [ok, setOk] = useState(false)

  const load = useCallback(() => {
    setLoading(true)
    fetchAuthConfig()
      .then(({ auth_mode, providers: p, ok: confident }) => {
        setAuthMode(auth_mode)
        setProviders(p)
        setOk(confident)
      })
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { authMode, providers, loading, ok, refetch: load }
}
